import Enum from '@/utils/enum.js'
/** 判断对象是否为空 为空时候返回ture */
function ISObject(Obj) {
  if (Obj === undefined || Obj === null) {
    return true
  }
  if (JSON.stringify(Obj) === '{}' || Object.keys(Obj).length === 0) {
    return true
  } else {
    return false
  }
}
/** 判断list是否为空 为空时候返回ture */
function ISArry(arry) {
  if (arry === undefined || arry === null) {
    return true
  }
  if (JSON.stringify(arry) === '[]' || Object.keys(arry).length === 0) {
    return true
  } else {
    return false
  }
}

/** 判断字符串是否为空 为空时候返回ture */
function ISStr(str) {
  if (str === null || str?.length <= 0 || str === undefined) {
    return true
  } else {
    return false
  }
}

/** A对象在B对象中存在的数据 */
function ContrastArry(Adata, Bdata, type) {
  var data = []
  Bdata.forEach(item => {
    Adata.forEach(i => {
      if (item[type] === i[type]) {
        data.push(i)
      }
    })
  })
  return data
}

/** A对象在B对象中不存在的数据 */
function ContrastNoArry(Adata, Bdata, type) {
  var data = []
  Adata.forEach(item => {
    const index = Bdata?.findIndex((a) => item[type] === a[type])
    if (index === -1) {
      data.push(item)
    }
  })
  return data
}

/** 根据code获取Name */
function ObtainListName(data, code) {
  if (!ISArry(data)) {
    var arr = data.filter(x => { return x.value === code })[0]
    if (!ISObject(arr)) {
      return arr.code
    }
  }
  return ''
}

/** string转数字 */
function ContrastNumber(Value) {
  const _Value = Number(Value)
  // 非数字，则返回0
  if (isNaN(_Value)) { return 0 }
  return _Value
}

/** 时间转换成年月6位日期字符串 */
function FormatDate(value) {
  const year = value.getFullYear()
  const month = (value.getMonth() + 1).toString().padStart(2, '0')
  return year + month
}

function EnumValueLocal(enumName, enumValue) {
  if (enumValue === null) return enumValue
  var localTxt = Enum[enumName][enumValue]
  if ( ISStr(localTxt)) { return '' }
  return localTxt
}

function EnumJobTypeValueLocal(enumName, enumValue, lang) {
  if (enumValue === null) return enumValue
  const currentLang = this?.$ls?.get('lang') || lang
  if (currentLang === 'en') {
    enumName = enumName + 'EN'
  }
  var localTxt = Enum[enumName][enumValue]
  if ( ISStr(localTxt)) { return '' }
  return localTxt
}

/** 时间右边大于等于左边任何时间 */
function DataTimeMap(data, name, value) {
  // 循环比对右边时间是否小于左边任何一个时间
  data.forEach((item, index, array) => {
    // 从当前元素的下一个元素开始比较
    for (let i = index + 1; i < array.length; i++) {
      if (array[i][name] < item[name]) {
        // 右边时间小于左边任何一个时间，赋值左边的 EventDT 为 null
        array[i][name] = value;
      }
    }
  });
  return data
}
export {
  ISArry,
  ISObject,
  ISStr,
  ContrastArry,
  ContrastNoArry,
  ObtainListName,
  ContrastNumber,
  FormatDate,
  EnumValueLocal,
  EnumJobTypeValueLocal,
  DataTimeMap
}
